import { apolloClient } from '@/setup/apollo-setup';
import { error } from '@/utils/notification';
import { GET_ME } from '@/queries/modules/system/me';

export async function getMe(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient.query({ query: GET_ME, fetchPolicy: 'network-only' });
    const { data, errors } = await result;

    if (errors) {
      context.commit('setError', error('notification.general-error-title', errors.map((x) => x.message).join(', ')));
      return null;
    }
    context.commit('setUserLogin', data.me.userLogin);
    context.commit('setSuccess', null);
    return data.me.userLogin;
  } catch (e) {
    // Never notify. This runs on every page load for every user, and a
    // signed-out or expired session already gets handled by the Apollo error
    // link -- a second toast here would be noise on top of a redirect.
    context.commit('setError', error('notification.general-error-title', e.message));
    return null;
  }
}
